import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrderForApproval";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";

addToChainAfter(chain, PopulateApiParameter, props => {
    const state = props.getState() as CustomApplicationState;
    const CustomState = state.KGPState.CheckoutReview;
    const isShippingServicesDisabled = state?.context?.session?.properties?.disableSpecialShippingServices === "true";
    const nextApproverPresent = props.apiParameter?.cart?.properties?.nextApproverPresent?.toLowerCase() === "true";
    const {
        SpecialDeliveryInstructionList,
        accountNumber,
        approvalNotes,
        workOrder,
        releaseNumber,
        packingListNotesList,
    } = CustomState;
    const deliveryInfo = state.KGPState.ShippingDeliveryInfoStore?.DeliveryInfo;
    props.apiParameter.cart.notes = approvalNotes || "";
    props.apiParameter.cart.properties = {
        shippingCollectAccountNumber: accountNumber || "",
        userSelectedSpecialDeliveryInstruction: (SpecialDeliveryInstructionList as string) || "",
        workOrderNumber: workOrder || "",
        releaseNumber: releaseNumber || "",
        packingListAndInstructions: packingListNotesList || "",
        customerOrderRefSelectedValue1: CustomState.customerReference1 || "",
        customerOrderRefSelectedValue2: CustomState.customerReference2 || "",
        customerOrderRefSelectedValue3: CustomState.customerReference3 || "",
        customerOrderRefSelectedValue4: CustomState.customerReference4 || "",
        Notes: localStorage.getItem("approverNotes") || "",
        cartContactName: CustomState.expeditedUserName || "",
        cartContactPhone: CustomState.expeditedUserphone || "",
        ...(!isShippingServicesDisabled && {
            selectedAccessorials: localStorage.getItem("checkoutAccessorial") || "",
            selectedAccessorialsDisplay: localStorage.getItem("checkoutAccessorialCompleted") || "",
        }),
        ...(deliveryInfo?.firstName && {
            deliveryContactFirstName: deliveryInfo?.firstName,
        }),
        ...(deliveryInfo?.lastName && {
            deliveryContactLastName: deliveryInfo?.lastName,
        }),
        ...(deliveryInfo?.phone && {
            deliveryContactPhone: deliveryInfo?.phone,
        }),
        ...(deliveryInfo?.email && {
            deliveryContactEmail: deliveryInfo?.email,
        }),
        ...(nextApproverPresent && {
            SendEmailToNextApprover: "true",
        }),
    };
    props.apiParameter.cart.poNumber = CustomState.poNumber || "";

    localStorage.removeItem("approverNotes");
    localStorage.removeItem("checkoutAccessorial");
    localStorage.removeItem("checkoutAccessorialCompleted");
    localStorage.removeItem("orderNotes");
});
